import watchUpdateDiversions from './updateDiversions';

const watchTransferNumbers = [watchUpdateDiversions];

export default watchTransferNumbers;
